import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';

export default function Home() {
  const webSiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '污视频安全资讯平台',
    url: 'https://example.com',
    description: '汇集污视频相关资讯、使用说明与安全提示，帮助用户识别虚假页面、恶意下载和隐私风险。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://example.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '安全资讯中心',
    url: 'https://example.com',
    description: '致力于为用户提供全面的网络安全资讯，帮助识别虚假页面、恶意下载和隐私风险。',
    sameAs: ['https://twitter.com/example', 'https://facebook.com/example'],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(webSiteLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <ArticleList />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}